"use client";

/** Chat chrome while FirstResponder still has no worker payload — not a blank "Loading chat...". */
export function HireChatLoading() {
  return (
    <div
      className="flex h-full min-h-0 flex-1 flex-col bg-aera-white"
      role="status"
      aria-busy="true"
      aria-label="กำลังโหลดแชท"
      data-testid="hire-chat-loading"
    >
      <div className="flex min-h-0 flex-1 items-center justify-start px-4 py-4">
        <div className="flex items-center gap-3">
          <div
            className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-aera-warmcream"
            aria-hidden
          >
            <span className="flex items-center gap-0.5">
              <span className="h-1.5 w-1.5 animate-bounce rounded-full bg-aera-charcoal [animation-delay:-0.3s]" />
              <span className="h-1.5 w-1.5 animate-bounce rounded-full bg-aera-charcoal [animation-delay:-0.15s]" />
              <span className="h-1.5 w-1.5 animate-bounce rounded-full bg-aera-charcoal" />
            </span>
          </div>
          <div className="min-w-0">
            <p className="text-sm font-semibold text-aera-charcoal">กำลังโหลดแชท</p>
            <p className="mt-0.5 text-sm text-aera-gray">กรุณารอสักครู่</p>
          </div>
        </div>
      </div>
      <div className="p-4">
        <div
          className="h-12 w-full rounded-lg border border-aera-lightgray/80 bg-aera-white"
          aria-hidden
        />
      </div>
    </div>
  );
}
